/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_f_dow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day of week`)
};

const es_cr_f_dow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Día de la semana`)
};

const de_cr_f_dow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochentag`)
};

const nl_cr_f_dow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dag van de week`)
};

const fr_cr_f_dow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jour de la semaine`)
};

const it_cr_f_dow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorno della settimana`)
};

const pt_br2_cr_f_dow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia da semana`)
};

const pt_cr_f_dow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia da semana`)
};

const ja_cr_f_dow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`曜日`)
};

const zh_cr_f_dow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`星期几`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_f_dow = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_f_dow(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_f_dow", locale)
	if (locale === "en") return en_cr_f_dow(inputs)
	if (locale === "es") return es_cr_f_dow(inputs)
	if (locale === "de") return de_cr_f_dow(inputs)
	if (locale === "nl") return nl_cr_f_dow(inputs)
	if (locale === "fr") return fr_cr_f_dow(inputs)
	if (locale === "it") return it_cr_f_dow(inputs)
	if (locale === "pt-BR") return pt_br2_cr_f_dow(inputs)
	if (locale === "pt") return pt_cr_f_dow(inputs)
	if (locale === "ja") return ja_cr_f_dow(inputs)
	return zh_cr_f_dow(inputs)
};